import { render, staticRenderFns } from "./ModalCreateBlockRule.vue?vue&type=template&id=0d81d152"
import script from "./ModalCreateBlockRule.vue?vue&type=script&lang=js"
export * from "./ModalCreateBlockRule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports